// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accountpage-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 20px 0;
    padding-top: 60px;
    font-family: "Rigidica Text Regular", sans-serif;
}

.accountpage-container {
    width: 100%;
    max-width: 500px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 30px;
}

.accountpage-title {
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
    font-family: "Rigidica Text Regular", sans-serif;
}

.accountpage-info {
    margin-bottom: 20px;
}

.accountpage-info-item {
    margin-bottom: 10px;
    font-size: 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.accountpage-info-label {
    font-weight: bold;
    margin-right: 10px;
    min-width: 120px;
    flex-shrink: 0;
}

.accountpage-info-value {
    flex: 1 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.accountpage-btn {
    width: 100%;
    background-color: #333;
    color: #fff;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
}

.accountpage-btn:hover {
    background-color: #555;
}

.accountpage-loading-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1;
}

.accountpage-loading {
    text-align: center;
    font-size: 24px;
    color: #333;
    font-family: "Rigidica Text Light", sans-serif;
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.accountpage-error {
    color: #ff0000;
    margin-bottom: 10px;
    text-align: center;
    font-size: 14px;
    font-family: "Rigidica Text Light", sans-serif;
    padding: 10px;
    background-color: #ffeeee;
    border: 1px solid #ff0000;
    border-radius: 4px;
}

.accountpage-edit-btn,
.accountpage-update-btn {
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    margin-left: 10px;
    cursor: pointer;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
}

.accountpage-edit-btn:hover,
.accountpage-update-btn:hover {
    background-color: #555;
}

.accountpage-edit-btn-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #999;
}

.accountpage-edit-btn-disabled:hover {
    background-color: #999;
}

.accountpage-edit-btn-disabled:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.accountpage-input {
    padding: 5px;
    margin-top: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 14px;
    margin-right: 10px;
    outline: none;
    flex: 1 1;
    min-width: 0;
    width: 100%;
}

.accountpage-info-item form {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
}

.accountpage-info-item form .accountpage-input {
    margin-top: 10px;
    width: 100%;
}

.accountpage-info-item form .accountpage-update-btn {
    margin-top: 10px;
    margin-left: 0;
}

.accountpage-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
}

.accountpage-tab {
    background: none;
    border: none;
    padding: 10px 20px;
    font-family: "Rigidica Text Regular", sans-serif;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    color: #666;
    transition: color 0.3s ease;
}

.accountpage-tab:hover {
    color: #333;
}

.accountpage-tab.accountpage-active {
    color: #333;
    font-weight: bold;
}

.accountpage-tab.accountpage-active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #333;
}

.accountpage-orders {
    margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/AccountPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,8CAA8C;IAC9C,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;IAC9C,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gDAAgD;IAChD,eAAe;IACf,yDAAyD;AAC7D;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,SAAO;IACP,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".accountpage-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: #ffffff;\n    padding: 20px 0;\n    padding-top: 60px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.accountpage-container {\n    width: 100%;\n    max-width: 500px;\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    padding: 30px;\n}\n\n.accountpage-title {\n    color: #333;\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.accountpage-info {\n    margin-bottom: 20px;\n}\n\n.accountpage-info-item {\n    margin-bottom: 10px;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.accountpage-info-label {\n    font-weight: bold;\n    margin-right: 10px;\n    min-width: 120px;\n    flex-shrink: 0;\n}\n\n.accountpage-info-value {\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.accountpage-btn {\n    width: 100%;\n    background-color: #333;\n    color: #fff;\n    padding: 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    margin-top: 10px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n}\n\n.accountpage-btn:hover {\n    background-color: #555;\n}\n\n.accountpage-loading-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 1;\n}\n\n.accountpage-loading {\n    text-align: center;\n    font-size: 24px;\n    color: #333;\n    font-family: \"Rigidica Text Light\", sans-serif;\n    padding: 20px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.accountpage-error {\n    color: #ff0000;\n    margin-bottom: 10px;\n    text-align: center;\n    font-size: 14px;\n    font-family: \"Rigidica Text Light\", sans-serif;\n    padding: 10px;\n    background-color: #ffeeee;\n    border: 1px solid #ff0000;\n    border-radius: 4px;\n}\n\n.accountpage-edit-btn,\n.accountpage-update-btn {\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 5px 10px;\n    margin-left: 10px;\n    cursor: pointer;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    transition: background-color 0.3s ease, opacity 0.3s ease;\n}\n\n.accountpage-edit-btn:hover,\n.accountpage-update-btn:hover {\n    background-color: #555;\n}\n\n.accountpage-edit-btn-disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: #999;\n}\n\n.accountpage-edit-btn-disabled:hover {\n    background-color: #999;\n}\n\n.accountpage-edit-btn-disabled:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.accountpage-input {\n    padding: 5px;\n    margin-top: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 14px;\n    margin-right: 10px;\n    outline: none;\n    flex: 1;\n    min-width: 0;\n    width: 100%;\n}\n\n.accountpage-info-item form {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.accountpage-info-item form .accountpage-input {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.accountpage-info-item form .accountpage-update-btn {\n    margin-top: 10px;\n    margin-left: 0;\n}\n\n.accountpage-tabs {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #ddd;\n}\n\n.accountpage-tab {\n    background: none;\n    border: none;\n    padding: 10px 20px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    font-size: 16px;\n    cursor: pointer;\n    position: relative;\n    color: #666;\n    transition: color 0.3s ease;\n}\n\n.accountpage-tab:hover {\n    color: #333;\n}\n\n.accountpage-tab.accountpage-active {\n    color: #333;\n    font-weight: bold;\n}\n\n.accountpage-tab.accountpage-active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #333;\n}\n\n.accountpage-orders {\n    margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
